import { useRef, useEffect } from 'react';

const CHAMPAGNE = '#E8B96A';
const CHAMPAGNE_LIGHT = '#F0C674';
const FG = '#F5F1FA';
const MUTED = '#A99FB8';

export function LandingHero() {
  return (
    <section
      style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: 1180,
        margin: '0 auto',
        padding: '100px 24px 64px',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 48,
      }}
    >
      <div>
        <Eyebrow />
        <Headline />
        <Sub />
        <CtaGroup />
      </div>
    </section>
  );
}

function Eyebrow() {
  return (
    <p
      className="landing-reveal-1"
      style={{
        fontFamily: "'Hanken Grotesk', sans-serif",
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: CHAMPAGNE,
        marginBottom: 24,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: CHAMPAGNE_LIGHT,
          boxShadow: `0 0 8px ${CHAMPAGNE_LIGHT}`,
        }}
      />
      Acesso antecipado &middot; primeiro lote &middot; vagas limitadas
    </p>
  );
}

function Headline() {
  return (
    <h1
      className="landing-reveal-2"
      style={{
        fontFamily: "'Fraunces', Georgia, serif",
        fontWeight: 400,
        fontSize: 'clamp(40px, 6.5vw, 86px)',
        lineHeight: 1.06,
        letterSpacing: '-0.02em',
        color: FG,
        marginBottom: 28,
        maxWidth: 820,
      }}
    >
      Nunca mais perca uma intimação{' '}
      <em
        style={{
          fontStyle: 'italic',
          fontWeight: 300,
          color: CHAMPAGNE_LIGHT,
        }}
      >
        de nenhum tribunal do Brasil.
      </em>
    </h1>
  );
}

function Sub() {
  return (
    <p
      className="landing-reveal-3"
      style={{
        fontFamily: "'Hanken Grotesk', sans-serif",
        fontSize: 'clamp(16px, 2vw, 19px)',
        lineHeight: 1.65,
        color: MUTED,
        maxWidth: 640,
        marginBottom: 44,
      }}
    >
      O VoxisAdv monitora as intimações de todos os tribunais por você, calcula o
      prazo automaticamente e avisa antes de vencer. Tudo num sistema simples de
      usar, sem precisar entrar no PJe, eProc ou eSAJ um por um.
    </p>
  );
}

function CtaGroup() {
  function scrollToForm() {
    document.getElementById('acesso')?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div
      className="landing-reveal-4"
      style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center' }}
    >
      <button
        onClick={scrollToForm}
        className="landing-cta-primary"
        style={{
          background: `linear-gradient(135deg, ${CHAMPAGNE} 0%, ${CHAMPAGNE_LIGHT} 100%)`,
          color: '#1A0F00',
          fontFamily: "'Hanken Grotesk', sans-serif",
          fontWeight: 600,
          fontSize: 15,
          letterSpacing: '0.01em',
          border: 'none',
          borderRadius: 10,
          padding: '14px 30px',
          cursor: 'pointer',
          boxShadow: `0 4px 32px rgba(232,185,106,0.35)`,
          transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(-2px)';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = `0 8px 40px rgba(232,185,106,0.5)`;
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.transform = 'translateY(0)';
          (e.currentTarget as HTMLButtonElement).style.boxShadow = `0 4px 32px rgba(232,185,106,0.35)`;
        }}
      >
        Garantir acesso antecipado
      </button>
      <span
        style={{
          fontFamily: "'Hanken Grotesk', sans-serif",
          fontSize: 13,
          color: MUTED,
          opacity: 0.7,
        }}
      >
        Sem cartão. Sem compromisso.
      </span>
    </div>
  );
}
